module.exports = __webpack_public_path__ + "img/sf_logo.47ff166f.png";